/**
 * Redact streaming-gateway auth from any string before it reaches a log, an
 * on-screen status, an error message, or a Sentry breadcrumb. Gateway URLs
 * carry `authorization` (and `routing-key`) as query-string params — on a
 * headset, console logs are streamed over adb/DevTools, and Sentry's default
 * fetch/XHR breadcrumbs record the full request URL — so the raw token must
 * never appear. Mirrors the `redactedForLogging` helper in the Apple client
 * (Portal-Apple-Client#423).
 */
export function redactGatewaySecrets(text: string): string {
  return text.replace(
    /([?&](?:authorization|routing-key)=)[^&\s]+/gi,
    "$1<redacted>",
  );
}
